import React, { Component } from 'react';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class RosterBMZ extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterWednesday1'>
      <div><Link to='/'>Home</Link></div>
      <h3>Member's Names</h3>
      <br />
      <br />

      <div><Link to='/conduct-torritb'>1.AAT 2058 MR.TORRIT BOONYAKIAT(Dojocho)</Link></div>
      <br />
      <div><Link to='/conduct-shosont'>2.AAT 5349 MR.SHOSON THATAWAKORN</Link></div>
      <br />
      <div><Link to='/conduct-stefank'>3.AAT 5461 MR.STEFAN KOKOSZA</Link></div>
      <br />
      <div><Link to='/conduct-niratb'>4.AAT 6571 MR.NIRAT BOONYASAWET</Link></div>
      <br />
      <div><Link to='/conduct-johnh'>5.AAT 6415 MR.JOHN HU</Link></div>
      <br />
      <div><Link to='/conduct-ratarmontrees'>6.AAT 6750 MR.RATARMONTREE SUKHOT</Link></div>
      <br />
      <div><Link to='/conduct-kannikad'>7.AAT 6751 MS.KANNIKA DEPPETTIKORN</Link></div>
      <br />
      <div><Link to='/conduct-zarawink'>8.AAT 6758 MR.ZARAWIN KANCHANAPORN</Link></div>
      <br />
      <div><Link to='/conduct-napasanunv'>9.AAT 7951 MS.NAPASANUN VONGVIVAT</Link></div>
      <br />
      <div><Link to='/conduct-issariyapar'>10.AAT 7952 MS.ISSARIYAPA ROOPSUWANNAKUL</Link></div>
      <br />
        <br />
        <div>
          Thailand's Aikido Association Class Attending System...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default RosterBMZ;
